import { useBuilderContext } from "../context/BuilderContext";
import { CustomDropdown } from "./CustomDropdown";
import Execute from "../../../images/Builder/execute.svg";
import ExecuteDark from "../../../images/Builder/execute_dark.svg";
import Save from "../../../images/save.svg";
import SaveDark from "../../../images/save_dark.svg";
import { useTheme } from "../../../context/ThemeContext";
import { useState } from "react";
import SaveStrategyModal from "./SaveStrategyModal";

export default function BasketBottom({
  showConfirmModal,
  strategyData,
  allOptionsData,
}) {
  const {
    lotx,
    handleLotxChange,
    selectedSymbol,
    marketType,
    handleMarketTypeChange,
  } = useBuilderContext();
  const { theme } = useTheme();
  const [isSaveModalOpen, setIsSaveModalOpen] = useState(false);

  const handleSaveClick = () => {
    setIsSaveModalOpen(true);
  };

  const handleSaveStrategy = (strategyName) => {
    const strategyToSave = {
      name: strategyName,
      legs: strategyData.map((leg) => ({
        isBuy: leg.isBuy,
        isCALL: leg.isCALL,
        strike: leg.strike,
        expiry: leg.expiry,
        lotSize: leg.lotSize,
      })),
      allOptionsData
    };

    // console.log("Saving strategy:", strategyToSave);

    setIsSaveModalOpen(false);
  };

  return (
    <div className="flex items-center gap-2 justify-between p-4 pt-3 border-t border-n100 border-opacity-30">
      <div className="gap-3 flex">
        <CustomDropdown
          label="LOT X:"
          options={[...Array(15)].map((_, i) => i + 1)}
          value={lotx}
          onChange={handleLotxChange}
        />
        <CustomDropdown
          options={["NRML", "MIS"]}
          value={marketType}
          onChange={handleMarketTypeChange}
        />
      </div>
      <div className="flex gap-4">
        <button
          className="text-[10px] px-4 py-2 bg-p400 text-p300 border border-n500 rounded flex gap-2"
          onClick={handleSaveClick}>
          <img
            src={theme === "dark" ? SaveDark : Save}
            alt="Execute icon"
            className="w-4 h-4"
          />
          <p>Save</p>
        </button>
        <button
          className="text-[10px] px-6 py-2 bg-swipe-button text-p400 rounded flex gap-2"
          onClick={showConfirmModal}>
          <img
            src={theme === "dark" ? ExecuteDark : Execute}
            alt="Execute icon"
            className="w-4 h-4"
          />
          <p>Execute</p>
        </button>
      </div>
      {isSaveModalOpen && (
        <SaveStrategyModal
          strategyData={{
            legs: strategyData,
            allOptionsData,
            selectedSymbol,
          }}
          onClose={() => setIsSaveModalOpen(false)}
          onSave={handleSaveStrategy}
        />
      )}
    </div>
  );
}
